import React from 'react';
import { PrivateDashboardHeader } from '@/features/dashboard/components/DashboardHeader/PrivateDashboardHeader';
import { PublicDashboardHeader } from '@/features/dashboard/components/DashboardHeader/PublicDashboardHeader';
import {
  DashboardType,
  PRIVATE_DASHBOARD,
  PUBLIC_DASHBOARD,
} from '@/features/dashboard/types';

export const DashboardHeader: React.FC<{
  onFullScreen: F0;
  // TODO: probably not needed
  // userInteraction: F<unknown, F<unknown>>;
  // updateDashboardFilters: F0;
  width: number;
  dashboardType: DashboardType;
}> = ({
  onFullScreen,
  // userInteraction,
  width,
  dashboardType,
  // updateDashboardFilters,
}) => {
  return (
    <>
      {dashboardType === PRIVATE_DASHBOARD && (
        <PrivateDashboardHeader
          onFullScreen={onFullScreen}
          // TODO: probably not needed
          // userInteraction={userInteraction}
          // updateDashboardFilters={updateDashboardFilters}
        />
      )}
      {dashboardType === PUBLIC_DASHBOARD && (
        <PublicDashboardHeader onFullScreen={onFullScreen} width={width} />
      )}
    </>
  );
};
